jQuery(document).ready(function () {

   // ADA (WCAG 4.1.3 — AudioEye #8): shared live region so cart actions
   // (add / quantity change / remove) are announced to screen readers. A single
   // sr-only region + helper is used by the cart JS (utilities.js, z__jsAjaxCart.js,
   // z__jsCart.js). Clearing then setting the text (re)triggers the announcement.
   window.Shopify = window.Shopify || {};
   Shopify.theme = Shopify.theme || {};
   if (!document.getElementById('ada-cart-status')) {
     // Known-good configuration. Two alternatives were tried and reverted after
     // testing:
     //   role="alert" + assertive  -> VoiceOver played its notification chime over
     //                                the speech, making the message unintelligible
     //   bare aria-live="assertive" -> the announcement stopped arriving at all and
     //                                the +/- controls lost focus after each press
     // Change ONE of these at a time if this is revisited; the two above were changed
     // together with the timing below, which made the cause impossible to attribute.
     jQuery('body').append('<div id="ada-cart-status" role="status" aria-live="polite" aria-atomic="true" class="is-sr-only"></div>');
   }
   Shopify.theme.a11yAnnounce = function (message) {
     var $region = jQuery('#ada-cart-status');
     if (!$region.length) { return; }
     $region.text('');
     window.setTimeout(function () { $region.text(message); }, 60);
   };

   // ADA (WCAG 4.1.3 — AudioEye #8): announcing at click time does not survive a
   // cart update. aria-live="polite" waits for a quiet moment, but the cart
   // re-render calls .focus() a moment later, and a focus change preempts the
   // pending announcement — so the new quantity was never spoken in the drawer.
   //
   // Queue the message instead and flush it once the re-render and focus restore
   // have finished, so it is the last thing to happen and nothing interrupts it.
   // The safety timer covers the case where no cart update follows (or the request
   // fails), so a queued message can never be lost silently.
   var __a11yPending = null;
   var __a11yPendingTimer = null;

   Shopify.theme.a11yQueueAnnounce = function (message) {
     __a11yPending = message;
     window.clearTimeout(__a11yPendingTimer);
     __a11yPendingTimer = window.setTimeout(function () {
       Shopify.theme.a11yFlushAnnounce();
     }, 1200);
   };

   Shopify.theme.a11yFlushAnnounce = function () {
     if (!__a11yPending) { return; }
     var message = __a11yPending;
     __a11yPending = null;
     window.clearTimeout(__a11yPendingTimer);
     // 1100ms: long enough to clear the refocus announcement. Shorter values put the
     // message inside that window, where a polite announcement is discarded — 150ms
     // was tried and the announcement stopped arriving entirely. The cost is that the
     // confirmation trails the focus announcement by about a second.
     window.setTimeout(function () { Shopify.theme.a11yAnnounce(message); }, 1100);
   };

   // ADA (WCAG 4.1.3 — AudioEye #8): announcing a quantity change through a live
   // region does not work in the cart. The update re-renders the cart and restores
   // focus, and that focus change either discards a polite message or, if made
   // assertive, triggers VoiceOver's alert chime over the speech.
   //
   // Instead, keep the +/- controls' accessible names in sync with the current
   // quantity. Focus is restored onto one of those controls straight after the
   // re-render, so the new value is spoken as part of the ordinary focus
   // announcement — "Increase quantity, currently 3, button". Nothing to race, no
   // timers, and nothing that can be dropped.
   Shopify.theme.a11ySyncQuantityLabels = function () {
     jQuery('.product-quantity-box').each(function () {
       var $box = jQuery(this);
       var val = jQuery('.quantity-input', $box).first().val();
       if (val === undefined || val === null || val === '') { return; }
       jQuery('.minus-control', $box).attr('aria-label', 'Decrease quantity, currently ' + val);
       jQuery('.plus-control', $box).attr('aria-label', 'Increase quantity, currently ' + val);
     });
   };
   Shopify.theme.a11ySyncQuantityLabels();

   // ADA (WCAG 2.1.2 — AudioEye #9): a cart quantity/remove change re-renders the
   // cart (page or modal) and otherwise throws focus to the top. Capture which
   // control the user was on — keyed by the stable line-item key (data-cart-item)
   // — and restore it after the re-render so keyboard users can keep progressing.
   Shopify.theme.a11ySaveCartFocus = function () {
     var $el = jQuery(document.activeElement);
     if (!$el.length) { return null; }
     var $line = $el.closest('[data-cart-item]');
     if (!$line.length) { return null; }
     var type;
     if ($el.closest('.plus-control').length) { type = 'plus'; }
     else if ($el.closest('.minus-control').length) { type = 'minus'; }
     else if ($el.is('.quantity-input') || $el.closest('.quantity-input').length) { type = 'input'; }
     // .ajax-cart__delete is deliberately not in these selectors: in the drawer it is a
     // non-interactive wrapper <span>, and .first() would otherwise pick it before the button.
     else if ($el.closest('[data-cart-page-delete], [data-ajax-cart-delete]').length) { type = 'remove'; }
     else { return null; }
     return { key: $line.attr('data-cart-item'), type: type };
   };
   Shopify.theme.a11yRestoreCartFocus = function (saved) {
     if (!saved || !saved.key) { return; }
     window.setTimeout(function () {
       var $line = jQuery('[data-cart-item="' + saved.key + '"]').filter(':visible').last();
       if (!$line.length) { return; }
       var $t;
       if (saved.type === 'plus') { $t = $line.find('.plus-control').first(); }
       else if (saved.type === 'minus') { $t = $line.find('.minus-control').first(); }
       else if (saved.type === 'remove') { $t = $line.find('[data-cart-page-delete], [data-ajax-cart-delete]').first(); }
       else { $t = $line.find('.quantity-input').first(); }
       if ($t && $t.length && $t.is(':visible')) { $t.trigger('focus'); }
     }, 80);
   };

   // setTimeout(()=>{
   //    jQuery('.minus-control').attr('role','button');
   //    jQuery('.minus-control').attr('tabindex','0');
   //    jQuery('.minus-control').attr('aria-label','increase');
   //    jQuery('.plus-control').attr('role','button');
   //    jQuery('.plus-control').attr('tabindex','0');
   //    jQuery('.plus-control').attr('aria-label','decrease');
   //  }, 5000);
  
 // jQuery(".product-wrap").find('a').attr("tabindex",'0').focus();
 //  jQuery(".product-wrap").find('a').attr("tabindex",'1').focus();
  
  $(".navbar-link svg").attr("aria-expanded", "false");
  // ADA (WCAG 2.4.3 Focus Order): nav links are natively focusable, so we no
  // longer force tabindex or call .focus() on page load. Forcing focus moved
  // the user away from the top of the page, and the positive tabindex="1" on
  // the announcement bar pulled it out of the natural DOM tab sequence.
  jQuery(".navbar-item.header__item:eq(2)").find('a').attr("tabindex",'0');
  jQuery(".navbar-item.header__item:eq(3)").find('a').attr("tabindex",'0');
  jQuery(".navbar-item.header__item:eq(6)").find('a').attr("tabindex",'0');
  jQuery(".navbar-item.header__item:eq(7)").find('a').attr("tabindex",'0');
  jQuery("body").on("keydown",".navbar-item:not(.navbar-link--active)", function(e){
      if(e.keyCode == 13) {
          jQuery(this).addClass("navbar-link--active");
          jQuery(".navbar-link--active").find('label a svg').attr("aria-expanded",'true');          
          jQuery('.navbar-item.header__item section').css("display", "block");  
          jQuery('.navbar-item.header__item .navbar-dropdown').css("display", "block");  
          e.preventDefault();
      }
    }); 
  
     jQuery("body").on("keyup",".navbar-item.header__item .navbar-link.header__link", function(e){
      if(e.keyCode == 9) {
        jQuery(this).focus();
        jQuery(".navbar-item").not(this).removeClass("navbar-link--active");
        jQuery(".navbar-item").not(this).find('a svg').attr('aria-expanded',"false");       
        jQuery('.navbar-item.header__item').not(this).find("section").css("display", "none");
        jQuery('.navbar-item.header__item').not(this).find(".navbar-dropdown").css("display", "none");
        e.preventDefault();
      }
    });
     jQuery("body").on("keydown", ".navbar-item.header__item a",  function(e) {
        if(e.keyCode == 27) {
          // Move focus to the NEXT top-level nav item so :focus-within
          // releases the current navbar-item (closing its submenu) and
          // the user can immediately tab into the next item without
          // being trapped in the just-closed dropdown.
          var $currentItem = jQuery(this).closest('.navbar-item.header__item');
          var $nextItem = $currentItem.nextAll('.navbar-item.header__item').first();
          if ($nextItem.length) {
            $nextItem.find('a.navbar-link.header__link').first().focus();
          } else {
            e.target.blur();
          }
          jQuery('.navbar-item.header__item').find('a svg').attr('aria-expanded',"false");
          jQuery('.navbar-item.header__item').removeClass("navbar-link--active");
          jQuery('.navbar-item.header__item section').css("display", "none");
          jQuery('.navbar-item.header__item .navbar-dropdown').css("display", "none");
          jQuery('.mega-menu__section').removeClass('is-active');
          e.preventDefault();
        }
   });

   // ADA (WCAG 4.1.2): the variant swatches now use a native <input type="radio">
   // group (see options-radios.liquid + custom-ada-style.css), which manages
   // selection and the checked state natively. The previous handler set
   // aria-checked on Tab *focus* (focus is not selection), which announced a
   // misleading state, so it has been removed.
   //
   // ADA (WCAG 2.1.1 Keyboard): keep the roving tabindex in sync after a selection
   // so the radiogroup stays a SINGLE Tab stop and Tab re-entry lands on the
   // currently selected swatch. options-radios.liquid seeds the tabindex at render;
   // this updates it whenever the user changes the selection (arrow keys or click).
   jQuery("body").on("change", ".swatch__options input[type='radio']", function () {
     var $group = jQuery(this).closest(".swatch__options");
     $group.find("input[type='radio']").attr("tabindex", "-1");
     jQuery(this).attr("tabindex", "0");
   });

//
    jQuery(".navbar-item.header__item:eq(9)").find('svg').remove();
  // 
   // jQuery("body").on("keyup",".ajax-cart__list .ajax-cart__product .qty-wrapper", function(e){
   //    if(e.keyCode == 9) {
   //      jQuery(".control.minus-control").attr("tabindex",'0').focus();
   //      jQuery(".control.plus-control").attr("tabindex",'1').focus();
   //    }
   // });


   // 
   // setTimeout(()=>{
   //      $('.boost-pfs-filter-display-item.boost-pfs-filter-display-grid').attr("aria-label", "Grid view");
   //      $('.boost-pfs-filter-display-item.boost-pfs-filter-display-list').attr("aria-label", "List view");
   //      $('.boost-pfs-filter-top-display-type a').click(function(){
   //          $('.boost-pfs-filter-display-item.boost-pfs-filter-display-grid.active').attr("aria-label", "Grid view selected");
   //          $('.boost-pfs-filter-display-item.boost-pfs-filter-display-list.active').attr("aria-label", "List view selected"); 
   //       })
   //   }, 10000);
  
  // console.log(jQuery(".header__menu .mega-menu__section:eq(0) .mega-menu__linklist "));
  // setTimeout(()=>{
  //      var i = 1;
  //      var j = 2
  //     jQuery(".header__menu .mega-menu__section:eq(0) .mega-menu__linklist ").each(function () {
  //     	var head= jQuery(this).find("h2").html();
  //     	jQuery(this).find("h2").attr('id', jQuery.trim(head))
  //     	var label=  jQuery(this).find("ul li:eq(0) a").html();
  //     	jQuery(this).find("ul li:eq(0) a").attr('id', 'Shop_All_'+j);  
  //     	jQuery(this).find("ul li:eq(0) a").attr('aria-labelledby', 'Shop_All_'+j +' '+jQuery.trim(head));
  //        i+=2;
  //        j+=2;
  //     })
      
  //     jQuery(".header__menu .mega-menu__section:eq(1) .mega-menu__linklist ").each(function () {
  //       var i = 1;
  //       var j = 2;
  //     	var head= jQuery(this).find("h2").html();
  //     	jQuery(this).find("h2").attr('id', jQuery.trim(head))
  //     	var label=  jQuery(this).find("ul li:eq(0) a").html();
  //     	jQuery(this).find("ul li:eq(0) a").attr('id', 'Shop_All_'+j);  
  //     	jQuery(this).find("ul li:eq(0) a").attr('aria-labelledby', 'Shop_All_'+j +' '+jQuery.trim(head));
  //        i+=2;
  //        j+=2;
  //     })
  //   }, 5000);

   
  
  //
  jQuery('.dynamic-sections').attr("role","main");

  //
  setTimeout(()=>{
    $('.boost-pfs-search-box').attr("aria-label", "");
    $('.boost-pfs-search-box').attr("aria-label","Search- Start typing, when autocomplete results are available use up and down arrows to review and enter to select");
  }, 5000);

  //
    $('.image-element__wrap:eq(0) img').attr('alt', 'Pants Store');
    $('.image-element__wrap .footer__logo').attr('alt', 'Pants Store');
  
  // ADA (WCAG 2.4.4 — AudioEye #14): removed
  //   jQuery('.banner--full-link').attr("aria-label","womens-gameday");
  // That stamped one hardcoded string onto EVERY full-slide link on the page, so a
  // slide linking to Rush Dresses announced itself as "womens-gameday". It is the
  // exact string AudioEye quoted, and because it ran after load it also overwrote the
  // per-slide names rendered by Liquid.
  // Names are now resolved per slide in index__slideshow-classic.liquid and
  // index__image-with-text-overlay.liquid, from the slide heading, the image alt, or
  // the title of whatever the slide links to.
 
  //
  setTimeout(()=>{
  jQuery('.heading-wrapper--recommended-products h4').replaceWith(function () {
     return jQuery("<h2>", {
     class: this.className,
     html: jQuery(this).html(),
     style: jQuery(this).attr('style')
             });
          });
      }, 5000);
  
 //
   setTimeout(()=>{
         jQuery(".boost-pfs-filter-option-item-list.boost-pfs-filter-option-item-list-multiple-list").before('<div class="sr-only cc-control">Activating the following form controls will update the content below.</div>');
         var incr = 1; 
         jQuery('.boost-pfs-filter-option-content-inner').each(function () {
           jQuery(this).find('.cc-control').attr('id', 'sr-instr-'+incr);
           jQuery(this).find('ul.boost-pfs-filter-option-item-list').attr('aria-labelledby', 'sr-instr-'+incr);
           incr+=1;
         })
     }, 5000);
     //
     
  // ADA (WCAG 3.3.2 / 4.1.2 — AudioEye #3): the Boost price-range filter's Min
  // and Max inputs are injected by the Boost app at runtime with no label, so
  // they can't be labeled in Liquid. Name them once Boost has rendered.
  setTimeout(()=>{
    jQuery('.boost-pfs-filter-option-range-amount').each(function () {
      jQuery(this).find('input').eq(0).attr('aria-label', 'Minimum price');
      jQuery(this).find('input').eq(1).attr('aria-label', 'Maximum price');
    });
  }, 5000);

  $('.action-area__link:eq(0)').attr('aria-label', 'Search Modal');
  $('.action-area__link:eq(1)').attr('aria-label', 'Account login');
//
  
  jQuery('.share-btn--twitter a').attr("aria-label","Share this on Twitter");
  jQuery('.share-btn--facebook a').attr("aria-label","Share this on Facebook");
  jQuery('.share-btn--pinterest a').attr("aria-label","Share this on Pinterest");
  jQuery('.share-btn--mail a').attr("aria-label","Email this to a friend");
  
  // //
  //  setTimeout(()=>{
  //       jQuery('.boost-pfs-filter-display-grid').attr("aria-label","Grid view");
  //       jQuery('.boost-pfs-filter-display-list').attr("aria-label","List view");
  // }, 3000);
  //
       setTimeout(()=>{
        jQuery('.boost-pfs-filter-product-item-image a').attr("aria-hidden","true");
        jQuery('.boost-pfs-filter-product-item-image a').attr("tabindex","-1");
      }, 5000);
 //
  // ADA (WCAG 3.3.2 / 2.4.6 — AudioEye #18 "Button Labels"): the visible "Sort by:"
  // label is now rendered server-side in snippets/boost-pfs-filter-html.liquid.
  // The 5s setTimeout that used to inject it from here has been removed: Boost
  // rebuilds the sorting button from its template on every sort/filter/page change,
  // which wiped the injected label, and the one-shot timer never put it back.

// ADA (WCAG 4.1.2 — AudioEye #5): removed a 5s setTimeout that set an aria-label on
  // the cart drawer's remove button. That button is now decorative (aria-hidden, out of
  // the tab order) and the surrounding link carries a per-item aria-label from
  // cart.ajax.liquid, so labelling it here would have put a name on a hidden element.
  // The old timer also only ran once, so items added later were never labelled.
  
  // ADA (WCAG 4.1.2 — AudioEye #5): the cart-page remove control is now labeled
  // per-item server-side in cart__main.liquid (aria-label on the link; the inner
  // button is decorative/aria-hidden), so the old 5s setTimeout that labeled the
  // inner button has been removed.

  //
     setTimeout(()=>{
              jQuery(".ajax-cart__list:eq(1) .ajax-cart__product").each(function( index ) {
               var title = jQuery(this).find('.ajax-cart__product-title a').html();
               jQuery(this).find('.qty-wrapper input').attr('title','Quantity - '+jQuery.trim(title));
         });
      }, 5000);
  //
      // setTimeout(()=>{  
      //   var head = jQuery('.header-cart__count.header-cart__count--badge.badge').html(); 
      //   jQuery('.count').html('Items'+ head)
      // }, 10000);
      // jQuery(".action_button").on( "click", function() {
      //   setTimeout(()=>{  
      //     var head = jQuery('.header-cart__count.header-cart__count--badge.badge').html();
      //     jQuery('.count').html('Items'+ head)
      //   }, 5000);
      // } ); 
      // // jQuery(".ajax-cart__delete .close").on( "click", function() {
      // //   alert()
      // //   // setTimeout(()=>{  
      // //   //   var head = jQuery('.header-cart__count.header-cart__count--badge.badge').html();
      // //   //   jQuery('.count').html('Items'+ head)
      // //   // }, 5000);
      // // } ); 
 // 
  
  jQuery('.product-7506809127094 h1').replaceWith(function () {
     return jQuery("<h2>", {
     class: this.className,
     html: jQuery(this).html(),
     style: jQuery(this).attr('style')
   });
});
 //
  
  jQuery('#26826770383030').attr("alt","Steve Madden Xandra Bodysuit");
  
  // 
setTimeout(()=>{
      jQuery('.boost-pfs-filter-toolbar-item.boost-pfs-filter-custom-sorting.boost-pfs-filter-top-sorting button').attr("aria-expananded","false");
      jQuery('.boost-pfs-filter-top-sorting').click(function(){ 
        if($('.boost-pfs-filter-top-sorting').hasClass('boost-pfs-filter-sort-active')) {
          jQuery('.boost-pfs-filter-toolbar-item.boost-pfs-filter-custom-sorting.boost-pfs-filter-top-sorting button').attr("aria-expananded","true");
        } else {
          jQuery('.boost-pfs-filter-toolbar-item.boost-pfs-filter-custom-sorting.boost-pfs-filter-top-sorting button').attr("aria-expananded","false");
        }
      });
    }, 5000);

  setTimeout(()=>{
    // jQuery('.header-cart .header__link').click(function(){
    //      $('.header-cart.action-area__link.has-cart-count').not(this).find('.product-wrap.enable-zoom-false').attr("aria-hidden", "true");
    //      $('.header-cart.action-area__link.has-cart-count').not(this).find('.product-wrap.enable-zoom-false').attr("tabindex",'-1');
    //   });
     
  }, 5000);

      jQuery('.header-cart .header__link').click(function(){
          jQuery(this).closest('body').find('#shopify-section-header-classic, [data-check-for-order="true"], #shopify-section-footer-classic').attr({
              'aria-hidden' : 'true',
              'tabindex' : '-1',
          });
      });

  setTimeout(() => {
    var i =1;
    
    jQuery('.navbar .header__menu li.navbar-item.header__item.has-mega-menu:eq(0), .navbar .header__menu li.navbar-item.header__item.has-mega-menu:eq(1)').each(function () {
        var menuText = jQuery(this).find('a').first().text().trim().toLowerCase().replace(/ /g,"_");
        
        jQuery(this).find('.mega-menu__linklist').each(function () {
            var menuHead = jQuery(this).find('.menu__heading').attr('id', menuText+ '_header_'+i);
            var menuLink = jQuery(this).find('ul>li>a').first().attr({
                'id' : menuText+ '_shop_'+i,
                'aria-labelledby' : menuText+ '_shop_'+i + ' ' + menuText+ '_header_'+i
            });
            
            i+=1;
        })
    })
  }, 1000)

  setTimeout(() => {
      jQuery('.product-recommendations li a.swatch').each(function () {
          var adaColorName = jQuery(this).find('.swatch__image').attr('alt');
          jQuery(this).attr('aria-label', adaColorName);    
      })
  }, 1500)
  
  
})


// jQuery(".ajax-cart__delete").on( "click", function() {
//         // setTimeout(()=>{  
//         alert()
          
//           // var head = jQuery('.header-cart__count.header-cart__count--badge.badge').html();
//           // jQuery('.count').html('Items'+ head)
//         // }, 5000);
//       } );







  